import { render, staticRenderFns } from "./PrestigeCampaignFilter.vue?vue&type=template&id=6f2d2322"
import script from "./PrestigeCampaignFilter.vue?vue&type=script&lang=js"
export * from "./PrestigeCampaignFilter.vue?vue&type=script&lang=js"
import style0 from "./PrestigeCampaignFilter.vue?vue&type=style&index=0&id=6f2d2322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports